export const reportService = {
  getChargerReport: (data) => window.axios.post("get-charger-report", data),
  getUserReport: (data) => window.axios.post("get-user-report", data),
  getUserAll: (data) => window.axios.post("getAllUser", data),
  getCompletedPayment: (data) =>
    window.axios.post("get-completed-payment", data),
};
